import { connect } from 'react-redux';

import { actionCreators, selectors } from 'dux/catalog';
import { selectors as flagSelectors } from 'dux/user';
import { actionCreators as ac } from 'dux/instances';
import ConfigSection from './ConfigSection';

const mapStateToProps = (state) => ({
  catalogConfigurations: selectors.getConfigurationState(state).configurations,
  flags: flagSelectors.getFeatureFlagsState(state, true).flags,
});

const mapDispatchToProps = {
  getCatalogConfiguration: actionCreators.getConfiguration,
  setInstanceConfiguration: ac.setInstanceConfiguration,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigSection);
